import React from 'react';
import { Box, Typography } from '@mui/material';
import { elliottTokens as t } from '../tokens';

// Brandy-filled pill (with cream border) used to advance a step, e.g. "I've got the gist"
// or "Move to the check-in". Text only: buttons carry no icon, so `icon` is accepted
// for older callers but not drawn.
const QuickReplyPill: React.FC<{ label: string; onClick?: () => void; icon?: 'check' | 'arrow' }> = ({
  label,
  onClick
}) => (
  <Box
    onClick={onClick}
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: '10px',
      py: '4px',
      borderRadius: '4px',
      cursor: onClick ? 'pointer' : 'default',
      border: '1.5px solid #f8de89',
      background: 'linear-gradient(180deg, rgba(247,148,32,0.75) 0%, rgba(241,90,38,0.75) 100%)',
      transition: 'filter 0.15s ease',
      '&:hover': onClick ? { filter: 'brightness(1.08)' } : undefined
    }}
  >
    <Typography sx={{ fontSize: 15, fontWeight: 600, lineHeight: 1.7, color: t.textPrimary, whiteSpace: 'nowrap' }}>
      {label}
    </Typography>
  </Box>
);

export default QuickReplyPill;
